import { render, staticRenderFns } from "./addSuccess.vue?vue&type=template&id=1c99b1a8&scoped=true"
import script from "./addSuccess.vue?vue&type=script&lang=ts"
export * from "./addSuccess.vue?vue&type=script&lang=ts"
import style0 from "./addSuccess.vue?vue&type=style&index=0&id=1c99b1a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c99b1a8",
  null
  
)

export default component.exports